<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters();"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- Searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              :disable="!hideFilters || activeFilters"
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="$store.state.stringsStore.strings.module.navigation.list.filter.label"
            />
          </div>
        </div>
      </div>
      <!-- Add button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn
          class="capitalize ctrl-button right"
          color="ctrl-turquoise"
          :label="`${$store.state.stringsStore.strings.action.add}`"
          @click="$router.push('/navigation/add')"
          icon-right="add"
        />
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
    <div v-if="!hideFilters" class="table-block q-mb-md">
      <div class="row q-pa-md" style="justify-content: space-between;">
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
            v-model="filters.title"
            @input="applyFilters"
            :float-label="getString('title')"/>
        </div>
      </div>
      <div class="row q-pa-md" style="justify-content: space-between;">
        <div class="q-pa-md" style="vertical-align: middle;">
          <q-btn
            :disable="!activeFilters"
            @click="resetFilters()"
            class="capitalize ctrl-button"
            :color="activeFilters ? 'primary' : 'grey-4'"
            label="Reset"
          />
        </div>
      </div>
    </div>
    </transition>
    <table-overview
      endpoint="navigation"
      :responseFormat="'menus'"
      :columns="columns"
      permission="navigation.menu"
      module="navigation"
      :selectable="false">
    </table-overview>
  </div>
</template>

<script>
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';
import EventBus from '@/event-bus';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';

export default {
  mixins: [
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  methods: {
    getString,
    removeRows(key) {
      EventBus.$emit('row-selection:delete', key);
    },
  },
  data() {
    return {
      isLoading: false,
      rowSelection: [],
      columns: [
        {
          name: '__slot:nav-title',
          title: getString('title'),
          sortField: 'title',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
        },
      ],
      filters: {
        title: '',
      },
      searchTerm: '',
      hideFilters: true,
    };
  },
  computed: {
    allowedRows() {
      return this.rowSelection.filter(val => val !== null);
    },
  },
  mounted() {
    EventBus.$on('row-selection:update', (payload) => {
      this.rowSelection = payload;
    });
  },
  destroyed() {
    EventBus.$off('row-selection:update');
  },
};
</script>
